/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalSnippetHitSchemaVisibility } from './universalSnippetHitSchemaVisibility';

export interface UniversalSnippetHitSchema {
  id: string;
  /** @maxLength 200 */
  name: string;
  visibility: UniversalSnippetHitSchemaVisibility;
}
